import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService } from 'kea-resource';

const controller = rpcController("ChoferRuta");
const crud = rpcCrudService<models.ChoferRuta, models.ChoferRutaDto>(controller);

export const ChoferRuta = cacheResource({
    ...crud,

    /**Deshabilita el chofer de ead */
    Deshabilitar: async (id: number): Promise<void> => await controller('Deshabilitar', { id }),

    /**Habilitar el chofer de ead */
    Habilitar: async (id: number): Promise<void> => await controller('Habilitar', { id }),

}, {

    }, {
        Deshabilitar: true,
        Habilitar: true
    });

const e = ChoferRuta;




// WEBPACK FOOTER //
// ./app/resources/items/choferruta.tsx